import React, { Fragment } from 'react';
import { SvgIcon } from 'core/icons';
import LoadImage from '../../common/images/LoadImage';

const Frame = ({ url }) => {
  return (
    <LoadImage url={url}>
      {({ isLoading }) => (
        <Fragment>
          <div
            className={`carousel-frame ${
              isLoading ? '' : 'carousel-frame--show'
            }`}
            style={{ backgroundImage: `url(${url})` }}
          />
          <div
            className={`carousel-frame overlay-progress ${
              isLoading ? 'overlay-progress--show' : ''
            }`}>
            <div className="overlay-progress__item">
              <SvgIcon name="spinner" className="overlay-progress__spinner" />
            </div>
          </div>
        </Fragment>
      )}
    </LoadImage>
  );
};

export default Frame;
